<template>
  <div
    style="background: white; width: 100%; overflow:hidden; margin-top: 10px; margin-bottom: 10px;"
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="formCreater"
      size="mini"
      :label-width="labelWidth || isMobile ? '80px' : '150px'"
      class="demo-formData"
    >
      <el-col v-for="item in formSchema" :span="item.span" :key="item.eName">
        <el-form-item
          v-if="item.condition ? formData[item.condition] : true"
          :label="item.type !== 'checkBox' ? item.name : ''"
          :prop="item.eName"
        >
          <el-input
            v-if="item.type === 'text'"
            v-model="formData[item.eName]"
          ></el-input>

          <el-input
            v-if="item.type === 'textArea'"
            type="textarea"
            :rows="6"
            v-model="formData[item.eName]"
          >
          </el-input>

          <el-input
            v-if="item.type === 'number'"
            :type="item.type"
            v-model="formData[item.eName]"
            @blur="inputBlur"
          ></el-input>
          <div v-if="item.type === 'timeRange'">
            <el-time-select
              v-model="formData[item.children[0].eName]"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }"
              placeholder="开始时间"
            >
            </el-time-select>
            -
            <el-time-select
              v-model="formData[item.children[1].eName]"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }"
              placeholder="结束时间"
            >
            </el-time-select>
          </div>

          <el-date-picker
            v-if="item.type === 'date'"
            style=""
            v-model="formData[item.eName]"
            value-format="yyyy-MM-dd"
            type="date"
            :placeholder="item.placeholder"
          >
          </el-date-picker>

          <el-date-picker
            v-if="item.type === 'datetime'"
            style=""
            v-model="formData[item.eName]"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            :placeholder="item.placeholder"
          >
          </el-date-picker>

          <div v-if="item.type === 'images'">
            <uploadComponent
              :imgList="formData[item.eName]"
              :id="item.eName"
              @onImageChanged="uploadChange"
            ></uploadComponent>
          </div>

          <div v-if="item.type === 'image'">
            <uploadComponent
              :imgList="formData[item.eName]"
              :id="item.eName"
              @onImageChanged="uploadChange"
              :limit="1"
            ></uploadComponent>
          </div>
          <div v-if="item.type === 'switch'">
            <el-switch
              :active-value="item.active"
              :inactive-value="item.inactive"
              v-model="formData[item.eName]"
            >
            </el-switch>
          </div>

          <div v-if="item.type === 'checkBox'">
            <el-checkbox v-model="formData[item.eName]">{{
              item.name
            }}</el-checkbox>
          </div>

          <div v-if="item.type === 'selector'">
            <el-select
              style="width: 100%;"
              v-model="formData[item.eName]"
              placeholder="请选择"
            >
              <el-option
                v-for="item in item.options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="item.type === 'chooseCity'">
            <el-select
              style="width: 100%;"
              v-model="formData[item.eName]"
              filterable
              remote
              reserve-keyword
              placeholder="请搜索并选择城市"
              :remote-method="onCitySearched"
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.fullname"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="item.type === 'chooseLocation'">
            <el-select
              v-model="formData[item.eName]"
              style="width: 100%;"
              filterable
              remote
              reserve-keyword
              placeholder="请搜索并选择详细地址"
              @change="onLocationChanged"
              :remote-method="onLocationSearched"
            >
              <el-option
                v-for="item in locationOptions"
                :key="item.id"
                :label="item.address"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="item.type === 'productSelector'">
            <el-transfer
              :titles="['所有商品', '参加活动的商品']"
              filter-placeholder="输入商品名"
              :props="{
                key: 'id',
                label: 'name'
              }"
              v-model="formData[item.eName]"
              :data="allProducts"
            >
            </el-transfer>
          </div>

          <div v-if="item.rules[0].trigger === 'always'">
            {{ item.rules[0].message }}
          </div>
        </el-form-item>
      </el-col>
    </el-form>
    <el-col>
      <div
        v-for="item in formBtn"
        :key="item.eName"
        style="text-align:center; padding-top: 20px;"
      >
        <el-button
          type="primary"
          :size="isMobile ? 'mini' : ''"
          :style="{
            width: item.width,
            'border-radius': isMobile ? '100px' : '0'
          }"
          @click="submitForm('formCreater', item.eName)"
        >
          {{ item.name }}
        </el-button>
      </div>
    </el-col>
  </div>
</template>

<script>
import uploadComponent from "@/views/components/upload-image.vue";
import { product } from "@/api/page-api";
export default {
  name: "form-creater",
  props: {
    formSchema: {
      type: null
    },
    formDataProp: {
      type: null
    },
    formBtn: {
      type: null
    },
    isMobile: {
      type: null
    },
    labelWidth: {
      type: null
    }
  },
  components: {
    uploadComponent
  },
  watch: {
    formDataProp: function(val) {
      this.initProductSelector();
      if (val) {
        this.formData = val;
      } else {
        this.initFormData();
      }
    }
  },
  data() {
    return {
      allProducts: [],
      formData: {},
      cityOptions: [],
      locationOptions: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入活动名称",
            trigger: "blur"
          },
          {
            min: 3,
            max: 5,
            message: "长度在 3 到 5 个字符",
            trigger: "blur"
          }
        ],
        region: [
          {
            required: true,
            message: "请选择活动区域",
            trigger: "change"
          }
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          {
            required: true,
            message: "请选择活动资源",
            trigger: "change"
          }
        ],
        desc: [
          {
            required: true,
            message: "请填写活动形式",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    if (this.formDataProp) {
      this.formData = this.formDataProp;
    } else {
      this.initFormData();
    }
    this.initFormRules();
    this.initProductSelector();
  },

  methods: {
    inputBlur() {
      window.scroll(0, 0);
    },
    initProductSelector() {
      if (this.formSchema.find(_el => _el.type === "productSelector")) {
        product.get({ pageSize: 999999 }).then(res => {
          if (res) {
            this.allProducts = res.data.list;
          }
        });
      }
    },
    initFormData() {
      const _formData = {};
      this.formSchema.forEach(_el => {
        switch (_el.type) {
          case "text": {
            _formData[_el.eName] = "";
            break;
          }
          case "switch": {
            _formData[_el.eName] = false;
            break;
          }
          case "timeRange": {
            _el.children.forEach(_child => {
              _formData[_child.eName] = "";
            });
            break;
          }
          case "images": {
            _formData[_el.eName] = [];
            break;
          }
          case "image": {
            _formData[_el.eName] = [];
            break;
          }
          case "productSelector": {
            product.get({}).then(res => {
              if (res) {
                this.allProducts = res.data.list;
              }
            });
            break;
          }
        }
      });
      this.formData = _formData;
    },

    initFormRules() {
      const _rules = {};
      this.formSchema.forEach(_el => {
        if (_el.rules && _el.rules.length > 0) {
          _rules[_el.eName] = _el.rules;
        }
        switch (_el.type) {
          case "timeRange": {
            _el.children.forEach(_child => {
              _rules[_child.eName] = _child.rules;
            });
            break;
          }
        }
      });
      this.rules = _rules;
    },

    uploadChange(params) {
      this.formData[params.eName] = params.images;
    },

    submitForm(formName, type) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit("formSubmit", {
            data: this.formData,
            type: type
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onCitySearched(params) {
      searchCity(params).then(res => {
        if (Array.isArray(res.result)) {
          this.cityOptions = res.result[0];
        }
      });
    },
    onLocationSearched(params) {
      searchLocation(params).then(res => {
        if (Array.isArray(res.data)) {
          this.locationOptions = res.data;
        }
      });
    },
    onLocationChanged(params) {
      if (params) {
        this.formData["address"] = params.address;
        this.formData["city"] = params.city;
        this.formData["location"] = params.location;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/components/formCreater.vue